import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shortcut", "children", "onClick"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Fragment, useEffect, useMemo } from 'react';
import { jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled
import { bind } from 'bind-event-listener';
import DeprecatedButton from '@atlaskit/button';
import { browser } from '@atlaskit/editor-common/browser';
import { buttonAutoFocusRingFix } from '../../styles/focus';
import { Shortcut } from '../Shortcut/Shortcut';
import { isKeyboardEventMatchShortcut } from './isKeyboardEventMatchShortcut';
/**
 * Component that renders a button with an optional keyboard shortcut.
 *
 * It binds a keydown event listener to the document to trigger the `onClick` function
 * when the `shortcut` is pressed.
 */
export function ButtonWithShortcut(_ref) {
  var shortcut = _ref.shortcut,
    children = _ref.children,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    var listener = function listener(event) {
      if (shortcut !== null && shortcut !== void 0 && shortcut.common && isKeyboardEventMatchShortcut(event, shortcut.common)) {
        event.preventDefault();
        event.stopPropagation();
        onClick === null || onClick === void 0 || onClick();
      }
    };
    return bind(document, {
      type: 'keydown',
      listener: listener
    });
  }, [onClick, shortcut]);
  var content = useMemo(function () {
    if (!shortcut) {
      return jsx(Fragment, null, children);
    }
    return jsx(Fragment, null, jsx("span", {
      "aria-keyshortcuts": browser.mac ? shortcut === null || shortcut === void 0 ? void 0 : shortcut.mac : shortcut === null || shortcut === void 0 ? void 0 : shortcut.windows
    }, children), jsx("span", {
      "aria-hidden": "true"
    }, jsx(Shortcut, {
      shortcut: shortcut
    })));
  }, [shortcut, children]);
  return (
    // Using DeprecatedButton allows css overriding.
    // The css override is necessary as workaround for fixing https://product-fabric.atlassian.net/browse/ED-18908.
    // TODO: Overriding should be removed and button should be replaced by @atlaskit/button/new once the issue is fixed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides
    jsx(DeprecatedButton, _extends({
      css: buttonAutoFocusRingFix,
      onClick: onClick
    }, rest), content)
  );
}